export default __webpack_public_path__ + "static/bubbles-f80ec483dae85e1c5fa346a14f1af923.mp4";